import axios from 'axios'
import {
  GET_REPORTS_DASHBOARD_COUNTS,
  GET_REPORTS_PROGRAMS_COUNTS,
} from './action-constants'

// const  DASHBOARD_COUNTS = 'reports/dashboardcounts/loginid'
const  DASHBOARD_COUNTS_2 = 'reports/dashboardcounts2'
// const  PROGRAMS_COUNTS = 'reports/programscount/loginid'
const  PROGRAMS_COUNTS_2 = 'reports/programscount'

export function getDashboardCounts (loginID) {
  console.log('4444 - 6641 ' );
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + DASHBOARD_COUNTS_2
  // const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + DASHBOARD_COUNTS + '/' + loginID
  return {
    type: GET_REPORTS_DASHBOARD_COUNTS,
    payload: new Promise((resolve, reject) => {
      axios
        .get(
          JSONURL
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}


export function getProgramCounts (loginID) {
  console.log('4444 - 6642 ' );
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + PROGRAMS_COUNTS_2
  // const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + PROGRAMS_COUNTS + '/' + loginID
  return {
    type: GET_REPORTS_PROGRAMS_COUNTS,
    payload: new Promise((resolve, reject) => {
      axios
        .get(
          JSONURL
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

